package org.example.zone360.pages.dashboard.coaches

import org.example.zone360.components.debugPrintln

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaEllipsisVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.FaUpload
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getSessionSummary
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomPagination
import org.example.zone360.components.MenuDropdown
import org.example.zone360.components.SearchBar
import org.example.zone360.components.ShimmerCircle
import org.example.zone360.components.formatSessionMinutes
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetClubCoachesData
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.GetSessionSummaryData
import org.example.zone360.models.MenuModel
import org.example.zone360.models.RemoveUserSeasonPayload
import org.example.zone360.models.TeamsObject
import org.example.zone360.pages.dashboard.SelectedBox
import org.example.zone360.pages.dashboard.coaches.coachesLayoutPopups.ConfirmationPopup
import org.example.zone360.pages.dashboard.coaches.coachesLayoutPopups.DisableCoachPopup
import org.example.zone360.pages.dashboard.coaches.coachesLayoutPopups.EnableCoach
import org.example.zone360.pages.dashboard.coaches.coachesLayoutPopups.RequestIndividualPopup
import org.example.zone360.pages.dashboard.playerAssessment.PlayersData
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.CoachesOrPlayer
import org.example.zone360.utils.Divider
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLImageElement
import org.example.zone360.utils.removeUserSeason

@Composable
fun CoachesLayout(
    coachesData: List<GetClubCoachesData>,
    playerData: List<GetPlayerData>,
    breakpoint: Breakpoint,
    onCoachesRecommendationClick: (GetClubCoachesData) -> Unit,
    onPlayerRecommendationClick: (GetPlayerData) -> Unit,
    addNewCoach: () -> Unit,
    addNewPlayer: () -> Unit,
    importPlayer: () -> Unit,
    importCoach: () -> Unit,
    onLimitReach: (Boolean) -> Unit,
    toastMessageCall: (String) -> Unit,

    ) {
    val sitePalette = ColorMode.current.toSitePalette()
    var selectedCoach by remember { mutableStateOf<GetClubCoachesData?>(null) }
    var isHovered by remember { mutableStateOf(false) }
    var isSelected by remember { mutableStateOf(CoachesOrPlayer.Coaches) }
    var searchText by remember { mutableStateOf("") }

    // Preload both coaches and players images
    LaunchedEffect(coachesData, playerData) {
        // Get coach URLs
        val coachUrls = coachesData
            .filter { it.imageUrl.isNotEmpty() }
            .take(10)
            .map { "${Res.Images.base_Image_Url}${it.imageUrl}" }

        // Get player URLs
        val playerUrls = playerData
            .filter { it.imageUrl.isNotEmpty() }
            .take(10)
            .map { "${Res.Images.base_Image_Url}${it.imageUrl}" }

        // Preload all
        val allUrls = coachUrls + playerUrls
        if (allUrls.isNotEmpty()) {
            console.log("Preloading ${allUrls.size} images")
            ImageLoadTracker.preload(allUrls)
        }
    }

    val filteredData = remember(searchText, playerData) {
        if (searchText.isEmpty()) playerData
        else playerData.filter { player ->
            val playerName = "${player.firstName} ${player.lastName}"
            playerName.contains(searchText, ignoreCase = true)
        }
    }

    val filteredCoach = remember(searchText, coachesData) {
        if (searchText.isEmpty()) coachesData
        else coachesData.filter { coach ->
            val coachName = "${coach.firstName} ${coach.lastName}"
            coachName.contains(searchText, ignoreCase = true)
        }
    }

    Box(
        modifier = Modifier
            .then(
                if (window.screen.width > 765) Modifier.height(915.px)
                else Modifier.maxHeight(915.px)
            )
            .width(
                if (breakpoint >= Breakpoint.XL) 68.percent else if (breakpoint > Breakpoint.LG) 59.percent
                else 100.percent
            )
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .margin(bottom = if (breakpoint <= Breakpoint.XL) 20.px else 0.px)
            .borderRadius(15.px)
            .overflow(
                overflowY = Overflow.Hidden,
                overflowX = Overflow.Auto
            )
            .padding(
                leftRight = if (breakpoint >= Breakpoint.LG) 30.px else 20.px,
                topBottom = if (breakpoint >= Breakpoint.LG) 20.px else 10.px
            )
    ) {
        Column(
            modifier = Modifier.width(100.percent)
                .fillMaxHeight(),

            ) {
            Row(
                modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap).rowGap(10.px)
                    .margin(bottom = 10.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.gap(20.px).flexWrap(FlexWrap.Wrap)
                ) {
                    Row(
                        modifier = Modifier
                            .borderRadius(6.px)
                            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                            .padding(leftRight = 5.px, topBottom = 4.px)
                            .border(1.px, LineStyle.Solid, Colors.LightGray),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        listOf(
                            CoachesOrPlayer.Coaches to "Coaches",
                            CoachesOrPlayer.Players to "Players"
                        ).forEach { (type, label) ->
                            SelectedBox(
                                text = label,
                                breakpoint = breakpoint,
                                width = 90.px,
                                height = 34.px,
                                fontSize = 15.px,
                                fontWeight = 500,
                                isSelected = isSelected == type,
                                onClick = {
                                    searchText = ""
                                    isSelected = type
                                }
                            )
                        }
                    }

                    if (isSelected == CoachesOrPlayer.Players) {
                        SearchBar(
                            placeholder = "Search player...",
                            id = "searchbar",
                            breakpoint = Breakpoint.LG,
                            modifier = Modifier.fillMaxWidth(),
                            onEnterClick = {},
                            onChange = { newSearchText ->
                                searchText = newSearchText
                            },
                            onClick = {},
                            width = if (window.screen.width > 510) 250.px else 100.percent,

                            showClearButton = false
                        )
                    } else {
                        SearchBar(
                            placeholder = "Search coach...",
                            id = "searchbarCoach",
                            breakpoint = Breakpoint.LG,
                            modifier = Modifier.fillMaxWidth(),
                            onEnterClick = {},
                            onChange = { newSearchText ->
                                searchText = newSearchText
                            },
                            onClick = {},
                            width = if (window.screen.width > 510) 250.px else 100.percent,
                            showClearButton = false
                        )
                    }
                }
                val modifier = if (window.screen.width < 510) Modifier.weight(1f) else Modifier
                if (isSelected == CoachesOrPlayer.Coaches) {
                    if (AppGlobal.userData.role == Strings.ADMIN) {
                        Row(
                            modifier = modifier.gap(12.px).thenIf(breakpoint < Breakpoint.MD){
                                Modifier.flexWrap(FlexWrap.Wrap)
                            },
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            CommonButton(
                                text = "Import Coaches",
                                backgroundColor = Colors.Transparent,
                                textSpanColor = sitePalette.textFieldTextColor.rgb,
                                borderColor = sitePalette.textFieldBorderColor.rgb,
                                icon = {
                                    FaUpload(
                                        size = IconSize.X1,
                                        modifier = Modifier.color(sitePalette.textFieldTextColor.rgb)
                                    )
                                },
                                width = 145.px,
                                height = 40.px,
                                onCLick = {
//                                    if (coachesData.size >= AppGlobal.userData.coachesAllowed) {
//                                        onLimitReach(true)
//                                        return@CommonButton
//                                    }
                                    importCoach()
                                })
                            CommonButton(
                                text = "Add New Coach",
                                icon = {
                                    FaPlus(
                                        size = IconSize.X1,
                                        modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb)
                                    )
                                },
                                width = 150.px,
                                height = 40.px,
                                onCLick = {
                                    if (AppGlobal.selectedSeason == Strings.DEFAULT_SEASON) {
                                        toastMessageCall("New coach can not be added when Default Season is selected")
                                        showToast(ToastID.ERROR)
                                        return@CommonButton
                                    }
                                    if (coachesData.size >= AppGlobal.userData.coachesAllowed) {
                                        onLimitReach(true)
                                        return@CommonButton
                                    }
                                    addNewCoach()
                                })
                        }
                    }
                } else {
                    Row(
                        modifier = modifier.gap(12.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        CommonButton(
                            text = "Import Players",
                           backgroundColor = Colors.Transparent,
                            textSpanColor = sitePalette.textFieldTextColor.rgb,
                            borderColor = sitePalette.textFieldBorderColor.rgb,
                            icon = {
                                FaUpload(
                                    size = IconSize.X1,
                                    modifier = Modifier.color(sitePalette.textFieldTextColor.rgb)
                                )
                            },
                            width = 135.px,
                            height = 40.px,
                            onCLick = {
                                importPlayer()
                            })
                        CommonButton(
                            text = "Add New Player",
                            icon = {
                                FaPlus(
                                    size = IconSize.X1,
                                    modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb)
                                )
                            },
                            width = 150.px,
                            height = 40.px,
                            onCLick = {
                                if (AppGlobal.selectedSeason == Strings.DEFAULT_SEASON) {
                                    toastMessageCall("New player can not be added when Default Season is selected")
                                    showToast(ToastID.ERROR)
                                    return@CommonButton
                                }
                                addNewPlayer()
                            })
                    }
                }
            }
            if (isSelected == CoachesOrPlayer.Coaches) {
                if (breakpoint >= Breakpoint.MD) {
                    Row(
                        modifier = Modifier.fillMaxWidth().height(50.px)
                            .backgroundColor(sitePalette.coachesTitleRow.rgb),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .fillMaxHeight()
                                .padding(leftRight = 10.px),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            FieldTitleTextNormalSimple(
                                text = "Name",
                                width = 130.px,
                                fontWeight = 500,
                                fontSize = 15.px
                            )
                            FieldTitleTextNormalSimple(
                                text = "Sessions",
                                width = 70.px,
                                fontWeight = 500,
                                fontSize = 13.px,
                                isClickable = true,
                                textAlign = TextAlign.Center
                            )

                            FieldTitleTextNormalSimple(
                                text = "Minutes",
                                width = 50.px,
                                fontWeight = 500,
                                fontSize = 13.px,
                                textAlign = TextAlign.Center
                            )
                            FieldTitleTextNormalSimple(
                                text = "Speaking",
                                width = 50.px,
                                fontWeight = 500,
                                fontSize = 13.px,
                                textAlign = TextAlign.Center
                            )
                            Row(
                                modifier = Modifier.width(60.px)
                                    .onMouseEnter { isHovered = true }
                                    .onMouseLeave { isHovered = false }
                                    .onClick {
//                                isSortedDescending = !isSortedDescending
//                                sortedData = if (isSortedDescending) {
//                                    data.sortedByDescending { it.count }
//                                } else {
//                                    data.sortedBy { it.count }
//                                }
                                    },
                                verticalAlignment = Alignment.CenterVertically
                            ) {
//                        if (isHovered) {
//                            if (isSortedDescending) {
//                                FaSortDown(
//                                    modifier = Modifier
//                                        .color(sitePalette.primary.rgb)
//                                        .margin(right = 5.px)
//                                        .cursor(Cursor.Pointer)
//                                )
//                            } else {
//                                FaSortUp(
//                                    modifier = Modifier
//                                        .color(sitePalette.primary.rgb)
//                                        .margin(right = 5.px)
//                                        .cursor(Cursor.Pointer)
//                                )
//                            }
//                        } else {
//                            CustomSpacer(16.px)
//                        }
                                FieldTitleTextNormalSimple(
                                    text = "Keywords",
                                    width = 50.px,
                                    fontWeight = 500,
                                    fontSize = 13.px,
                                    isClickable = false,
                                    textAlign = TextAlign.Center
                                )
                            }
//                    FieldTitleTextNormalSimple(
//                        text = "Efficiency",
//                        width = 50.px,
//                        fontWeight = 500,
//                        fontSize = 13.px
//                    )

                            FieldTitleTextNormalSimple(
                                text = "Emphasis",
                                width = 50.px,
                                fontWeight = 500,
                                fontSize = 13.px,
                                textAlign = TextAlign.Center
                            )
                            FieldTitleTextNormalSimple(
                                text = "Recommendations",
                                width = 130.px,
                                fontWeight = 500,
                                fontSize = 13.px,
                                textAlign = TextAlign.Center
                            )
                            if (AppGlobal.userData.role == Strings.ADMIN) {
                                FieldTitleTextNormalSimple(
                                    text = "Actions",
                                    width = 65.px,
                                    fontWeight = 500,
                                    fontSize = 13.px,
                                )
                            }

                        }
                    }
                    HorizontalDivider(
                        modifier = Modifier.fillMaxWidth().margin(0.px).height((0.5).px)
                            .backgroundColor(sitePalette.textFieldBorderColor.rgb)
                    )
                }
                Column(
                    modifier = Modifier.fillMaxWidth().height(750.px)
                        .maxHeight(800.px)
                        .overflow(Overflow.Auto)
                ) {
                    if (filteredCoach.isNotEmpty()) {
                        CoachesData(
                            data = filteredCoach,
                            onRecommendationClick = { coach ->
                                selectedCoach = coach
                                onCoachesRecommendationClick(coach)
                            },
                            toastMessageCall = toastMessageCall,
                            breakpoint = breakpoint,
                            playerData = playerData
                        )
                    }
                }
            } else {
                if (breakpoint >= Breakpoint.MD) {
                    Row(
                        modifier = Modifier.fillMaxWidth().height(50.px)
                            .backgroundColor(sitePalette.coachesTitleRow.rgb),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .padding(leftRight = 10.px),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            FieldTitleTextNormalSimple(
                                text = "Name",
                                width = 110.px,
                                fontWeight = 500,
                                fontSize = 15.px,
                            )
                            FieldTitleTextNormalSimple(
                                text = "Assessments",
                                width = 135.px,
                                fontWeight = 500,
                                isClickable = false,
                                textAlign = TextAlign.Center
                            )
                            FieldTitleTextNormalSimple(
                                text = "Mentions/Tags",
                                width = 120.px,
                                fontWeight = 500,
                                textAlign = TextAlign.Center
                            )

                            FieldTitleTextNormalSimple(
                                text = "Coach",
                                width = 120.px,
                                fontWeight = 500,
                                textAlign = TextAlign.Center,

                                )
                            FieldTitleTextNormalSimple(
                                text = "Team",
                                width = 150.px,
                                fontWeight = 500,
                                textAlign = TextAlign.Center,

                                )

                            FieldTitleTextNormalSimple(
                                text = "Email",
                                width = if (window.screen.width in 800..1600) 230.px else 310.px,
                                fontWeight = 500,
                                textAlign = TextAlign.Center,
                            )
                            FieldTitleTextNormalSimple(
                                text = "Recommendations",
                                width = 130.px,
                                fontWeight = 500,
                                isClickable = false,
                                textAlign = TextAlign.Center
                            )
                            if (AppGlobal.selectedSeasonId.isNotEmpty()) {
                                FieldTitleTextNormalSimple(
                                    text = "Action",
                                    width = 70.px,
                                    fontWeight = 500,
                                    textAlign = TextAlign.Center
                                )
                            }

                        }
                    }
                    HorizontalDivider(
                        modifier = Modifier.fillMaxWidth().margin(0.px).height((0.5).px)
                            .backgroundColor(sitePalette.textFieldBorderColor.rgb)
                    )
                }
                Column(
                    modifier = Modifier.fillMaxWidth().maxHeight(750.px)
                        .then(
                            if (breakpoint >= Breakpoint.MD) Modifier.height(750.px)
                            else Modifier
                        )
                        .overflow(overflowY = Overflow.Auto, overflowX = Overflow.Hidden)
                ) {
                    if (filteredData.isNotEmpty()) {
                        PlayersData(
                            data = filteredData,
                            onRecommendationClick = onPlayerRecommendationClick,
                            breakpoint = breakpoint,
                            toastMessage = toastMessageCall,
                            sitePalette = sitePalette
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun CoachesData(
    data: List<GetClubCoachesData>,
    breakpoint: Breakpoint,
    onRecommendationClick: (GetClubCoachesData) -> Unit = {},
    toastMessageCall: (String) -> Unit,
    playerData: List<GetPlayerData>,

    ) {

    val ctx = rememberPageContext()
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()
    var actionPopup by remember { mutableStateOf(false) }
    var coachId by remember { mutableStateOf("") }
    var coachName by remember { mutableStateOf("") }
    var coachEmail by remember { mutableStateOf("") }
    var teamsData by remember { mutableStateOf<List<TeamsObject>>(emptyList()) }
    var disableCoach by remember { mutableStateOf(false) }
    var enableCoach by remember { mutableStateOf(false) }
    var reqIndividual by remember { mutableStateOf(false) }
    var removeCoach by remember { mutableStateOf(false) }
    var isRemoving by remember { mutableStateOf(false) }
    var selectedRequestType by remember { mutableStateOf("") }

    // Track loaded images globally for all coaches
//    val imageLoadStates = remember { mutableStateMapOf<String, Boolean>() }
////
//    LaunchedEffect(data) {
//        data.forEach { coach ->
//            if (coach.imageUrl.isNotEmpty()) {
//                val url = "${Res.Images.base_Image_Url}${coach.imageUrl}"
//
//                if (ImageCacheManager.isImageLoaded(url)) {
//                    imageLoadStates[url] = true
//                } else {
//                    val img = window.document.createElement("img") as HTMLImageElement
//                    img.addEventListener("load", {
//                        imageLoadStates[url] = true
//                        ImageCacheManager.markAsLoaded(url)
//                    })
//                    img.addEventListener("error", {
//                        imageLoadStates[url] = true
//                        ImageCacheManager.markAsLoaded(url)
//                    })
//                    img.src = url
//                    imageLoadStates[url] = false
//                }
//            }
//        }
//    }


    if (disableCoach) {
        DisableCoachPopup(
            onDismiss = { disableCoach = false },
            toastMessage = toastMessageCall,
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            coachId = coachId,
        )
    }
    if (enableCoach) {
        EnableCoach(
            onDismiss = { enableCoach = false },
            toastMessage = toastMessageCall,
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            coachId = coachId,
        )
    }
    if (reqIndividual) {
        RequestIndividualPopup(
            onDismiss = { reqIndividual = false },
            toastMessage = toastMessageCall,
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            coachId = coachId,
            coachName = coachName,
            coachEmail = coachEmail,
            teamList = teamsData
        )
    }

    if (removeCoach) {
        ConfirmationPopup(
            onDismiss = { removeCoach = false },
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            title = "Remove Coach",
            message = "Are you sure you want to remove this coach?",
            isLoading = isRemoving,
            onConfirm = {
                scope.launch {
                    try {
                        isRemoving = true
                        val payload = RemoveUserSeasonPayload(
                            userID = coachId,
                            seasonID = AppGlobal.selectedSeasonId,
                            organization = AppGlobal.userData.organization
                        )
                        val response = removeUserSeason(payload)
                        if (response.error.isNullOrBlank()) {
                            toastMessageCall(response.message ?: "")
                            showToast(ToastID.SUCCESS)
                            AppGlobal.refreshSessions = getCurrentMilliseconds().toString()
                            removeCoach = false
                        } else {
                            toastMessageCall(response.error)
                            showToast(ToastID.ERROR)
                        }

                    } catch (ce: CancellationException) {
                        throw ce
                    } catch (_: Exception) {
                        toastMessageCall("Failed to remove this coach")
                        showToast(ToastID.ERROR)
                    } finally {
                        isRemoving = false
                    }
                }

            }
        )
    }

    if (actionPopup) {
        AssessmentPopup(
            onDialogDismiss = { actionPopup = false },
            toastMessage = toastMessageCall,
            onSaveChanges = {

            },
            breakpoint = breakpoint,
            playerData = playerData,
            coachId = coachId,
            coachName = coachName,
            coachEmail = coachEmail,
            initialRequestType = selectedRequestType
        )
    }
    val sortedCoaches = data.sortedWith(
        compareByDescending<GetClubCoachesData> { it.efficiency }
            .thenByDescending { it.count }
    )
    var isExpanding by remember { mutableStateOf(false) }
    val sessionSummary = remember { mutableStateListOf<GetSessionSummaryData>() }
    var isLoading by remember { mutableStateOf(false) }


    if (breakpoint >= Breakpoint.MD) {
        sortedCoaches.forEach { coach ->
            val validCoach =
                AppGlobal.userData.role == Strings.COACH && coach.userId != AppGlobal.userData.uid
            Row(
                modifier = Modifier.fillMaxWidth()
                    .margin(topBottom = 10.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween

            ) {
                Row(
                    modifier = Modifier.width(140.px)
                        .cursor(if (validCoach) Cursor.Default else Cursor.Pointer)
                        .onClick {
                            if (AppGlobal.userData.role == Strings.COACH) {
                                if (coach.userId == AppGlobal.userData.uid) {
                                    ctx.router.navigateTo("/coach-details?userId=${coach.userId}")
                                } else {
                                    toastMessageCall("Coaches can only view their own profile.")
                                    showToast(ToastID.ERROR)
                                }
                            } else {
                                ctx.router.navigateTo("/coach-details?userId=${coach.userId}")
                            }
                        },
                    verticalAlignment = Alignment.CenterVertically,
                )
                {
                    // Replace this entire if/else block for the image:
                    if (coach.imageUrl.isNotEmpty()) {
                        FastImage(
                            url = "${Res.Images.base_Image_Url}${coach.imageUrl}",
                            size = 30,
                            modifier = Modifier.margin(right = 7.px)
                        )
                    } else {
                        Image(
                            src = Res.Images.userIcon,
                            modifier = Modifier.size(30.px).margin(right = 7.px).borderRadius(100.px)
                        )
                    }
//                    if (coach.imageUrl.isNotEmpty()) {
//                        val imageUrl = "${Res.Images.base_Image_Url}${coach.imageUrl}"
//                        val isLoaded = imageLoadStates[imageUrl] ?: false
//
//                        Box(modifier = Modifier.size(30.px).margin(right = 7.px)) {
//                            // Always show user icon as base
//                            Image(
//                                src = Res.Images.userIcon,
//                                modifier = Modifier.fillMaxSize().borderRadius(100.px)
//                            )
//
//                            // Shimmer effect overlay while loading
//                            if (!isLoaded) {
//                                ShimmerCircle(
//                                    modifier = Modifier.fillMaxSize().borderRadius(100.px)
//                                )
//                            }
//
//                            // Actual image when loaded
//                            if (isLoaded) {
//                                Image(
//                                    src = imageUrl,
//                                    modifier = Modifier.fillMaxSize().borderRadius(100.px)
//                                )
//                            }
//                        }
//                    } else {
//                        Image(
//                            src = Res.Images.userIcon,
//                            modifier = Modifier.size(30.px).margin(right = 7.px)
//                                .borderRadius(100.px)
//                        )
//                    }

                    FieldTitleTextNormalSimple(
                        text = "${coach.firstName} ${coach.lastName}"
                            .split(" ")
                            .joinToString(" ") { word ->
                                word.lowercase().replaceFirstChar { it.titlecase() }
                            },
                        fontSize = 13.px,
                        isClickable = true,
                        width = 100.px,
                        wordBreak = WordBreak.Normal,
                        overflowWrap = OverflowWrap.BreakWord,
                        color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb

                    )
                }
                FieldTitleTextNormalSimple(
                    text = if (coach.count > 0) coach.count.toString() else "-",
                    width = 70.px,
                    fontSize = 13.px,
                    textAlign = TextAlign.Center,
                    color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb

                )
                FieldTitleTextNormalSimple(
                    text = if (coach.count > 0) (coach.recordTime / 1000).formatSessionMinutes() else "-",
                    width = 50.px,
                    fontSize = 13.px,
                    textAlign = TextAlign.Center,
                    color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb

                )
                FieldTitleTextNormalSimple(
                    text = if (coach.count > 0) "${
                        if (coach.recordTime == 0) 0 else (((coach.speakingTime * 1000) / coach.recordTime) * 100).toInt()
                    } %" else "-",
                    width = 40.px,
                    fontSize = 13.px,
                    textAlign = TextAlign.Center,
                    color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb

                )
                FieldTitleTextNormalSimple(
                    text = if (coach.count > 0) coach.totalKeywords.toString() else "-",
                    width = 60.px,
                    fontSize = 13.px,
                    textAlign = TextAlign.Center,
                    color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb

                )
//            FieldTitleTextNormalSimple(
//                text = if (coach.count > 0) (coach.efficiency.asDynamic().toFixed(1) as String) else "-",
//                width = 50.px,
//                fontSize = 13.px,
//                textAlign = TextAlign.Center
//            )
                FieldTitleTextNormalSimple(
                    text = coach.emphasis.ifEmpty { "-" }.replaceFirstChar {
                        if (it.isLowerCase()) it.titlecase() else it.toString()
                    },
                    fontSize = 13.px,
                    width = 40.px,
                    textAlign = TextAlign.Center,
                    color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb

                )
                Box(
                    modifier = Modifier.width(130.px),
                    contentAlignment = Alignment.Center
                ) {
                    CommonButton(
                        text = "View",
                        textSpanColor = if (coach.count > 0 && !validCoach) sitePalette.viewText.rgb else sitePalette.commonButtonSupportiveTextColor.rgb,
                        backgroundColor = if (coach.count > 0 && !validCoach) sitePalette.viewButtonBackground.rgb else sitePalette.textFieldBorderColorDisabled.rgb,
                        width = 64.px,
                        height = 28.px,
                        pointerCursor = coach.count > 0,
                        onCLick = {
                            if (coach.count > 0) {
                                if (AppGlobal.userData.role == Strings.COACH) {
                                    if (coach.userId == AppGlobal.userData.uid) {
                                        onRecommendationClick(coach)
                                    } else {
                                        debugPrintln("Access denied: Coaches can only view their own data.")
                                    }
                                } else {
                                    onRecommendationClick(coach)
                                }
                            }
                        }
                    )
                }
                if (AppGlobal.userData.role == Strings.ADMIN) {
                    Box(
                        modifier = Modifier.width(70.px),
                        contentAlignment = Alignment.Center
                    ) {
                        val menuItems = if (coach.disabled) {
                            listOf(
                                MenuModel(text = "Enable Coach", route = "")
                            )
                        } else {
                            listOfNotNull(
                                MenuModel(text = "Disable Coach", route = ""),
                                if (coach.count <= 0 && AppGlobal.selectedSeasonId.isNotEmpty()) MenuModel(
                                    text = "Remove Coach from season",
                                    route = ""
                                ) else null,
                                MenuModel(text = "Request Match", route = ""),
                                MenuModel(text = "Request Training", route = ""),
                                MenuModel(text = "Request Team's Assessment", route = ""),
                                MenuModel(text = "Request Individual Assessment", route = "")
                            )
                        }
                        MenuDropdown(
                            icon = {
                                FaEllipsisVertical(
                                    modifier = Modifier.width(15.px).height(10.px)
                                        .padding(left = 11.px).margin(bottom = 2.px)
                                        .color(sitePalette.textFieldTextColor.rgb)
                                )
                            },
                            data = menuItems,
                            onSelect = {
                                when (it) {
                                    "Disable Coach" -> {
                                        coachId = coach.userId
                                        disableCoach = true
                                    }

                                    "Remove Coach from season" -> {
                                        coachId = coach.userId
                                        removeCoach = true
                                    }

                                    "Enable Coach" -> {
                                        coachId = coach.userId
                                        enableCoach = true
                                    }

                                    "Request Match" -> {
                                        selectedRequestType = "Request Match"
                                        coachId = coach.userId
                                        coachName = "${coach.firstName} ${coach.lastName}"
                                        actionPopup = true
                                    }

                                    "Request Training" -> {
                                        selectedRequestType = "Request Training"
                                        coachId = coach.userId
                                        coachName = "${coach.firstName} ${coach.lastName}"
                                        actionPopup = true
                                    }

                                    "Request Team's Assessment" -> {
                                        coachId = coach.userId
                                        coachName = "${coach.firstName} ${coach.lastName}"
                                        coachEmail = coach.email
                                        teamsData = coach.teams
                                        reqIndividual = true
                                    }

                                    "Request Individual Assessment" -> {
                                        selectedRequestType = "Request Assessment"
                                        coachId = coach.userId
                                        coachName = "${coach.firstName} ${coach.lastName}"
                                        coachEmail = coach.email
                                        actionPopup = true
                                    }
                                }
                            }
                        )
                    }
                }
            }
            Divider()
        }
    } else {
        var currentPage by remember { mutableStateOf(0) }
        val sessionsPerPage = 1
        val totalPages = (sortedCoaches.size + sessionsPerPage - 1) / sessionsPerPage
        val coach = sortedCoaches[currentPage]

        key(coach.userId) {
            val validCoach =
                AppGlobal.userData.role == Strings.COACH && coach.userId != AppGlobal.userData.uid
            LaunchedEffect(isExpanding) {
                if (isExpanding) {
                    isLoading = true
                    try {
                        val sessionUser = getSessionSummary(
                            userID = coach.userId,
                            domainType = "soccer",
                            language = "en",
                            getAll = true,
                            isPlayer = false,
                            sessionType = "training",
                            organization = AppGlobal.userData.organization
                        )
                        sessionSummary.clear()
                        sessionSummary.addAll(sessionUser.data)
                    } catch (ce: CancellationException) {
                        throw ce
                    } catch (_: Throwable) {
                        debugPrintln("Failed to fetch session summary.")
                    } finally {
                        isLoading = false
                    }
                }
            }
            Column(modifier = Modifier.fillMaxWidth().margin(top = 10.px)) {
                Column(
                    modifier = Modifier.fillMaxWidth()
                        .onClick {
                            if (AppGlobal.userData.role == Strings.COACH) {
                                if (coach.userId == AppGlobal.userData.uid) {
                                    ctx.router.navigateTo("/coach-details?userId=${coach.userId}")
                                } else {
                                    toastMessageCall("Coaches can only view their own profile.")
                                    showToast(ToastID.ERROR)
                                }
                            } else {
                                ctx.router.navigateTo("/coach-details?userId=${coach.userId}")
                            }
                        })
                {
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Name",
                            fontSize = 15.px,
                            fontWeight = 550,
                            width = if (breakpoint < Breakpoint.MD) 55.percent else 40.percent
                        )
                        Row(
                            modifier = Modifier.width(60.percent)
                                .cursor(if (validCoach) Cursor.Default else Cursor.Pointer)
                                .onClick {
                                },
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            if (coach.imageUrl.isNotEmpty()) {
                                FastImage(
                                    url = "${Res.Images.base_Image_Url}${coach.imageUrl}",
                                    size = 30,
                                    modifier = Modifier.margin(right = 7.px)
                                )
                            } else {
                                Image(
                                    src = Res.Images.userIcon,
                                    modifier = Modifier.size(30.px)
                                        .margin(right = 7.px)
                                        .borderRadius(100.px)
                                )
                            }
//                            if (coach.imageUrl.isNotEmpty()) {
//                                val imageUrl = "${Res.Images.base_Image_Url}${coach.imageUrl}"
//                                val isLoaded = imageLoadStates[imageUrl] ?: false
//
//                                Box(modifier = Modifier.size(30.px).margin(right = 20.px)) {
//                                    // Always show user icon (visible when not loaded)
//                                    Image(
//                                        src = Res.Images.userIcon,
//                                        modifier = Modifier.size(30.px).borderRadius(100.px)
//                                    )
//
//                                    // Shimmer effect overlay while loading
//                                    if (!isLoaded) {
//                                        ShimmerCircle(
//                                            modifier = Modifier.size(30.px).borderRadius(100.px)
//                                        )
//                                    }
//
//                                    // Actual image fades in when loaded
//                                    if (isLoaded) {
//                                        Image(
//                                            src = imageUrl,
//                                            modifier = Modifier.size(30.px).borderRadius(100.px)
//                                                .textAlign(TextAlign.Start)
//                                        )
//                                    }
//                                }
//                            } else {
//                                Image(
//                                    src = Res.Images.userIcon,
//                                    modifier = Modifier.size(30.px).margin(right = 7.px)
//                                        .borderRadius(100.px)
//                                )
//                            }
                            FieldTitleTextNormalSimple(
                                text = "${coach.firstName} ${coach.lastName}"
                                    .split(" ")
                                    .joinToString(" ") { word ->
                                        word.lowercase().replaceFirstChar { it.titlecase() }
                                    },
                                fontSize = 15.px,
                                isClickable = true,
                                wordBreak = WordBreak.Normal,
                                overflowWrap = OverflowWrap.BreakWord,
                                color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb

                            )
                        }

                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Session:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = if (breakpoint < Breakpoint.MD) 60.percent else 40.percent
                        )
                        FieldTitleTextNormalSimple(
                            text = if (coach.count > 0) coach.count.toString() else "-",
                            width = 60.percent,
                            fontSize = 15.px,
                            marginLeft = 60.px,
                            color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb

                        )
                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Minutes:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = if (breakpoint < Breakpoint.MD) 60.percent else 40.percent
                        )
                        FieldTitleTextNormalSimple(
                            text = if (coach.count > 0) (coach.recordTime / 1000).formatSessionMinutes() else "-",
                            width = 60.percent,
                            fontSize = 15.px,
                            marginLeft = 60.px,
                            color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb

                        )
                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Speaking:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = if (breakpoint < Breakpoint.MD) 60.percent else 40.percent
                        )
                        FieldTitleTextNormalSimple(
                            text = if (coach.count > 0) "${
                                if (coach.recordTime == 0) 0 else (((coach.speakingTime * 1000) / coach.recordTime) * 100).toInt()
                            } %" else "-",
                            width = 60.percent,
                            fontSize = 15.px,
                            marginLeft = 60.px,
                            color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb


                        )
                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Keyword:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = if (breakpoint < Breakpoint.MD) 60.percent else 40.percent
                        )
                        FieldTitleTextNormalSimple(
                            text = if (coach.count > 0) coach.totalKeywords.toString() else "-",
                            width = 60.percent,
                            fontSize = 15.px,
                            marginLeft = 60.px,
                            color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb


                        )
                    }
                    Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                        FieldTitleTextNormalSimple(
                            text = "Emphasis:",
                            fontSize = 15.px,
                            fontWeight = 500,
                            width = if (breakpoint < Breakpoint.MD) 60.percent else 40.percent
                        )
                        FieldTitleTextNormalSimple(
                            text = coach.emphasis.ifEmpty { "-" }.replaceFirstChar {
                                if (it.isLowerCase()) it.titlecase() else it.toString()
                            },
                            width = 60.percent,
                            marginLeft = 60.px,
                            fontSize = 15.px,
                            color = if (coach.disabled) sitePalette.commonButtonSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb
                        )
                    }
                }
                Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                    FieldTitleTextNormalSimple(
                        text = "Recommendations",
                        fontSize = 15.px,
                        fontWeight = 500,
                        width = 40.percent
                    )
                    Box(
                        modifier = Modifier.width(60.percent),
                        contentAlignment = Alignment.Center
                    ) {
                        CommonButton(
                            text = "View",
                            textSpanColor = if (coach.count > 0 && !validCoach) sitePalette.viewText.rgb else sitePalette.commonButtonSupportiveTextColor.rgb,
                            backgroundColor = if (coach.count > 0 && !validCoach) sitePalette.viewButtonBackground.rgb else sitePalette.textFieldBorderColorDisabled.rgb,
                            width = 64.px,
                            height = 28.px,
                            pointerCursor = coach.count > 0,
                            onCLick = {
                                if (coach.count > 0) {
                                    if (AppGlobal.userData.role == Strings.COACH) {
                                        if (coach.userId == AppGlobal.userData.uid) {
                                            onRecommendationClick(coach)
                                        } else {
                                            debugPrintln("Access denied: Coaches can only view their own data.")
                                        }
                                    } else {
                                        onRecommendationClick(coach)
                                    }
                                }
                            }
                        )
                    }
                }
                Row(modifier = Modifier.fillMaxWidth().margin(bottom = 10.px)) {
                    FieldTitleTextNormalSimple(
                        text = "Action",
                        fontSize = 15.px,
                        fontWeight = 500,
                        width = 65.percent
                    )
                    if (AppGlobal.userData.role == Strings.ADMIN) {
                        Box(
                            modifier = Modifier.width(70.px)
                                .display(DisplayStyle.Flex).justifyContent(
                                    JustifyContent.Start
                                ),
                            contentAlignment = Alignment.Center
                        ) {
                            val menuItems = if (coach.disabled) {
                                listOf(
                                    MenuModel(text = "Enable Coach", route = "")
                                )
                            } else {
                                listOfNotNull(
                                    MenuModel(text = "Disable Coach", route = ""),
                                    if (coach.count <= 0 && AppGlobal.selectedSeasonId.isNotEmpty()) MenuModel(
                                        text = "Remove Coach from season",
                                        route = ""
                                    ) else null,
                                    MenuModel(text = "Request Match", route = ""),
                                    MenuModel(text = "Request Training", route = ""),
                                    MenuModel(text = "Request Team's Assessment", route = ""),
                                    MenuModel(text = "Request Individual Assessment", route = "")
                                )
                            }

                            MenuDropdown(
                                icon = {
                                    FaEllipsisVertical(
                                        modifier = Modifier.width(15.px).height(10.px)
                                            .padding(left = 11.px).margin(bottom = 2.px)
                                            .color(sitePalette.textFieldTextColor.rgb)
                                    )
                                },
                                data = menuItems,
                                onSelect = {
                                    when (it) {
                                        "Disable Coach" -> {
                                            coachId = coach.userId
                                            disableCoach = true
                                        }

                                        "Remove Coach from season" -> {
                                            coachId = coach.userId
                                            removeCoach = true
                                        }

                                        "Enable Coach" -> {
                                            coachId = coach.userId
                                            enableCoach = true
                                        }

                                        "Request Match" -> {
                                            selectedRequestType = "Request Match"
                                            coachId = coach.userId
                                            coachName = "${coach.firstName} ${coach.lastName}"
                                            actionPopup = true
                                        }

                                        "Request Training" -> {
                                            selectedRequestType = "Request Training"
                                            coachId = coach.userId
                                            coachName = "${coach.firstName} ${coach.lastName}"
                                            actionPopup = true
                                        }

                                        "Request Team's Assessment" -> {
                                            coachId = coach.userId
                                            coachName = "${coach.firstName} ${coach.lastName}"
                                            coachEmail = coach.email
                                            teamsData = coach.teams
                                            reqIndividual = true
                                        }

                                        "Request Individual Assessment" -> {
                                            selectedRequestType = "Request Assessment"
                                            coachId = coach.userId
                                            coachName = "${coach.firstName} ${coach.lastName}"
                                            coachEmail = coach.email
                                            actionPopup = true
                                        }
                                    }
                                }

                            )
                        }
                    }
                }



                if (totalPages > 1) {
                    Column(modifier = Modifier.fillMaxWidth()) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.End
                        ) {
                            CustomPagination(
                                currentPage = currentPage,
                                totalPages = totalPages,
                                onPageChange = { newPage -> currentPage = newPage },
                                sitePalette = sitePalette,
                                leftRightPadding = 0.px,
                                topBottomPadding = 0.px
                            )
                        }
                    }

                }
            }
        }
    }
}


// 1. IMAGE CACHE MANAGER
// ============================================
object ImageLoadTracker {
    private val loadedImages = mutableSetOf<String>()

    fun markLoaded(url: String) {
        loadedImages.add(url)
    }

    fun isLoaded(url: String): Boolean = loadedImages.contains(url)

    fun preload(urls: List<String>) {
        urls.forEach { url ->
            if (!isLoaded(url)) {
                val img = document.createElement("img") as HTMLImageElement
                img.addEventListener("load", {
                    markLoaded(url)
                })
                img.src = url
            }
        }
    }
}

@Composable
fun FastImage(
    url: String,
    size: Int = 30,
    modifier: Modifier = Modifier,
    fallbackIcon: String = Res.Images.userIcon
) {
    var sitePalette = ColorMode.current.toSitePalette()
    var isLoaded by remember(url) { mutableStateOf(ImageLoadTracker.isLoaded(url)) }

    LaunchedEffect(url) {
        if (!isLoaded) {
            val startTime = getCurrentMilliseconds()
            val img = document.createElement("img") as HTMLImageElement

            img.addEventListener("load", {
                val loadTime = getCurrentMilliseconds() - startTime
                console.log("✅ Image loaded in ${loadTime}ms: ${url.take(50)}")
                ImageLoadTracker.markLoaded(url)
                isLoaded = true
            })

            img.addEventListener("error", {
                console.error("❌ Failed to load: ${url.take(50)}")
                isLoaded = true
            })

            img.src = url
        }
    }

    Box(
        modifier = modifier
            .size(size.px)
            .borderRadius(100.px)
            .backgroundColor(Colors.DarkGray)
    ) {
        Image(
            src = fallbackIcon,
            modifier = Modifier.fillMaxSize().borderRadius(100.px)
        )

        if (!isLoaded) {
            ShimmerCircle(
                modifier = Modifier.fillMaxSize().borderRadius(100.px)
            )
        } else {
            Image(
                src = url,
                modifier = Modifier.fillMaxSize().borderRadius(100.px).objectFit(ObjectFit.Cover)
            )
        }
    }
}
